// extracted by mini-css-extract-plugin
module.exports = {"root":"_2zcD-","preview":"_1JA6n","next":"_3xv4x","prev":"_3ibGu"};